<template>
  <div class="details" v-loading="detailLoading">
    <van-swipe class="my-swipe" :autoplay="3000" :show-indicators="false">
      <van-swipe-item v-for="item in swipe">
        <img class="swipe-img" :src="imgUrl + item">
      </van-swipe-item>
    </van-swipe>
    <div class="commodity-info">
      <div class="money-of-sum">￥{{ commodity.price_yuan }}</div>
      <div class="school-uniform-title">{{ commodity.name }}</div>
      <div class="commodity-introduction">商品介绍：{{ commodity.descript }}</div>
    </div>
    <!-- <div class="commodity-popup">
        <van-cell is-link @click="show = true">{{select_commodity}}</van-cell> -->
    <van-popup v-model="show" position="bottom" get-container="#app" :style="{ height: '2000px' }">
      <div>
        <van-sku v-model="show" :sku="sku" :goods="commodity" :goods-id="commodity.id" :buy-text="language_cut.sku_btn"
                 :show-add-cart-btn='false' :initial-sku="initialSku" :hide-stock="false" @buy-clicked="onBuyClicked"
                 @add-cart="onAddCartClicked"/>
      </div>
    </van-popup>
    <!-- </div> -->
    <div class="commodity-info">
      <!-- 商品详情： -->
      <div v-html="commodity.detail">{{ commodity.detail }}</div>
    </div>
    <div class="details-bottom-btn">
      <div class="shopping_trolley-icon">
        <van-icon name="cart-o" @click="go_shopping_trolley" :badge="shopping_trolley_list.length"/>
        {{ language_cut.shopping_trolley }}
      </div>

      <div>
        <button class="add-btn" @click="show_popup('add')">{{ language_cut.add_btn }}</button>
        <button class="buy-btn" @click="show_popup('buy')">{{ language_cut.buy_btn }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      detailLoading: true,
      imgUrl: this.$commonVariable.imgUrl,
      shopping_trolley_list: '',
      commodity: {},      // 商品信息
      swipe: [],
      select_commodity: '选择商品',
      show: false,
      goods: {},
      sku: {},
      initialSku: {},
      buy_val: '',      // 点击商品sku弹出层的确定按钮时的值
      language_cut: {
        shopping_trolley: '',
        add_btn: '',
        buy_btn: '',
        sku_btn: '',
      },
    }
  },
  created() {
    this.call_details()
    this.shopping_trolley_list = JSON.parse(sessionStorage.shopping_trolley_list)
  },
  mounted() {
    this.language_cut_fun()
  },
  methods: {
    language_cut_fun() {     // 语言切换
      if (sessionStorage.language == 'en') {
        this.language_cut = {
          shopping_trolley: 'cart',
          add_btn: 'add shopping cart',
          buy_btn: 'buy immediately',
          sku_btn: 'yes',
        }
      } else {
        this.language_cut = {
          shopping_trolley: '购物车',
          add_btn: '加入购物车',
          buy_btn: '立即购买',
          sku_btn: '确定',
        }
      }
    },
    call_details() {
      this.detailLoading = true
      this.$service.details(this.$route.query.guid).then(res => {
        this.detailLoading = false
        if (res.code === 20000) {
          this.commodity = res.data.goods;   // 商品信息
          this.commodity.picture = this.$commonVariable.imgUrl + res.data.goods.pic;   // 商品信息

          this.commodity.price_yuan = this.pub_fun.centToYuan(this.commodity.price)
          res.data.sku.tree.forEach(item => {
            item.v.forEach(item1 => {
              item1.imgUrl = this.$commonVariable.imgUrl + res.data.goods.pic
              item1.previewImgUrl = this.$commonVariable.imgUrl + res.data.goods.pic
            })
          })
          if (res.data.sku.list) {
            this.initialSku = res.data.sku.list[0]
          } else {
            res.data.sku.price = this.pub_fun.centToYuan(res.data.sku.price)
            res.data.sku.imgUrl = this.$commonVariable.imgUrl + res.data.goods.pic
            res.data.sku.previewImgUrl = this.$commonVariable.imgUrl + res.data.goods.pic
          }
          this.sku = res.data.sku;
          if (this.commodity.gallery === '') {
            this.swipe = [this.commodity.pic]
          } else {
            this.swipe = this.commodity.gallery.split(',');    // 轮播图
          }
        } else {
          alert("商品请求失败！请刷新后重试")
        }
      })
    },
    go_shopping_trolley() {     // 进入购物车
      this.$router.push({
        path: '/shopping_trolley',
      })
    },
    show_popup(val) {
      this.show = true
      this.buy_val = val
    },
    onBuyClicked(obj) {     // 商品规格立即购买
      if (this.buy_val == 'add') {
        this.add(obj)
        this.show = false
      } else {
        this.shopping_trolley_list.forEach(item => {
          item.is_check = false
        })
        let sku = ''
        let idSku = ''
        this.sku.tree.forEach(item => {
          idSku = obj.selectedSkuComb.id
          item.v.forEach(element => {
            if (element.id == obj.selectedSkuComb[item.k_s]) {
              sku = element.name
            }
          });
        })
        let shopping_trolley = [{
          goodsId: this.commodity.id,
          title: this.commodity.name,
          price: obj.selectedSkuComb.price,
          price_yuan: this.pub_fun.centToYuan(obj.selectedSkuComb.price),
          // price_yuan: this.commodity.price_yuan,
          img: this.commodity.pic,
          num: obj.selectedNum,
          sku: sku,
          is_check: false,
          idSku: idSku,
        }]
        sessionStorage.setItem('immediately_buy_list', JSON.stringify(shopping_trolley))
        this.$router.push({
          path: '/submit_order',
        })
        this.show = false;
      }
    },
    onAddCartClicked(obj) {     // 商品规格加入购物车
      this.add(obj)
      this.show = false
    },
    add(obj, is_check = false) {    // 加入购物车公共方法
      console.log(obj);
      let sku = ''
      let idSku = ''
      this.sku.tree.forEach(item => {
        idSku = obj.selectedSkuComb.id
        item.v.forEach(element => {
          if (element.id == obj.selectedSkuComb[item.k_s]) {
            sku = element.name
          }
        });
      })
      let shopping_trolley = {
        goodsId: this.commodity.id,
        title: this.commodity.name,
        price: obj.selectedSkuComb.price,
        price_yuan: this.pub_fun.centToYuan(obj.selectedSkuComb.price),
        // price_yuan: this.commodity.price_yuan,
        img: this.commodity.pic,
        num: obj.selectedNum,
        sku: sku,
        is_check: is_check,
        idSku: idSku,
      }
      if (this.look_shopping_trolley(shopping_trolley) == 'false') {
        this.shopping_trolley_list.push(shopping_trolley)
        sessionStorage.setItem('shopping_trolley_list', JSON.stringify(this.shopping_trolley_list))
      } else {
        this.shopping_trolley_list.forEach(item => {
          if (item.goodsId == shopping_trolley.goodsId && item.idSku == shopping_trolley.idSku && item.price == shopping_trolley.price && item.sku == shopping_trolley.sku) {
            item.num += shopping_trolley.num
            sessionStorage.setItem('shopping_trolley_list', JSON.stringify(this.shopping_trolley_list))
          }
        })
      }
    },
    look_shopping_trolley(shopping_trolley) {
      if (this.shopping_trolley_list.length > 0) {
        for (let i = 0; i < this.shopping_trolley_list.length; i++) {
          if (this.shopping_trolley_list[i].goodsId == shopping_trolley.goodsId && this.shopping_trolley_list[i].idSku == shopping_trolley.idSku && this.shopping_trolley_list[i].price == shopping_trolley.price && this.shopping_trolley_list[i].sku == shopping_trolley.sku) {
            return 'true'
          }
          if (i == this.shopping_trolley_list.length - 1) {
            return 'false'
          }
        }
      } else {
        return 'false'
      }
    },
  },
}
</script>

<style lang="less">
.details {

  .van-sku-actions {
    padding: 20px 16px;
  }

  .swipe-img {
    width: 100%;
    height: 4rem;
  }

  img {
    width: 100%;
  }

  .commodity-info {
    background-color: #FFF;
    padding: 0.3rem 0.4rem;
    margin-bottom: 0.25rem;

    > div {
      margin-bottom: 0.3rem;
    }

    .school-uniform-title {
      padding: 0;
    }

    .commodity-details, .commodity-introduction {
      font-size: 0.2rem;
      color: #A3A3A3;
      line-height: 1.5;
    }
  }

  .commodity-popup {
    background-color: #FFF;
    padding: 0 0.4rem;
    margin-bottom: 0.25rem;
  }

  .details-bottom-btn {
    height: 1rem;
    background-color: #FFF;
    width: 100%;
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    padding: 0.15rem 0.4rem;
    display: flex;
    z-index: 99;
    justify-content: space-between;
    align-items: center;
    // padding-left: 1rem;

    button {
      width: 2.5rem;
      height: 0.7rem;
      border-radius: 0.5rem;
      color: #FFF;
      font-size: 0.25rem;
    }

    .shopping_trolley-icon {
      width: 1.5rem;
      font-size: 0.15rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #616161;

      .van-icon-cart-o {
        font-size: 0.35rem;
        color: #000;
        margin-bottom: 0.03rem;
      }
    }

    .add-btn {
      background: linear-gradient(to right, #093268 0%, #2A548D 100%);
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }

    .buy-btn {
      background: linear-gradient(to right, #F08708 0%, #F9A909 100%);
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
}
</style>
